import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const location = useLocation();
  const [state, setState] = useState({ status: 'loading', message: '', data: null });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (!token) {
      setState({ status: 'error', message: 'Missing verification token.', data: null });
      return;
    }
    axios
      .get(`${API}/auth/verify-id-email`, { params: { token } })
      .then((res) => setState({ status: 'success', message: res.data.message, data: res.data }))
      .catch((err) => setState({ status: 'error', message: err.response?.data?.detail || 'Verification failed.', data: null }));
  }, [location.search]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="verify-email-page">
      <div className="max-w-md w-full bg-white p-8 rounded-xl border border-slate-200 shadow-sm text-center">
        <Link to="/" className="text-2xl font-serif font-bold text-slate-900 mb-6 block">The Case Verse</Link>
        {state.status === 'loading' && (
          <div data-testid="verify-loading">
            <Loader2 className="w-10 h-10 text-slate-500 mx-auto animate-spin mb-4" />
            <p className="text-slate-600">Verifying your email…</p>
          </div>
        )}
        {state.status === 'success' && (
          <div data-testid="verify-success">
            <div className="mx-auto w-14 h-14 rounded-full bg-green-100 flex items-center justify-center mb-4">
              <CheckCircle2 className="w-8 h-8 text-green-600" />
            </div>
            <h1 className="text-2xl font-serif font-bold text-slate-900 mb-2">Email verified</h1>
            <p className="text-slate-600 mb-2">{state.message}</p>
            {state.data?.institute_name && (
              <p className="text-sm text-slate-500 mb-6">
                Access provisioned by <strong>{state.data.institute_name}</strong> as a <strong>{state.data.role === 'instructor' ? 'Faculty' : 'Student'}</strong> member.
              </p>
            )}
            <Link to="/login" className="inline-block px-6 py-3 bg-slate-900 text-white rounded-lg hover:bg-slate-800" data-testid="verify-login-btn">
              Log in now
            </Link>
          </div>
        )}
        {state.status === 'error' && (
          <div data-testid="verify-error">
            <div className="mx-auto w-14 h-14 rounded-full bg-red-100 flex items-center justify-center mb-4">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
            <h1 className="text-2xl font-serif font-bold text-slate-900 mb-2">Verification failed</h1>
            <p className="text-slate-600 mb-6">{state.message}</p>
            <Link to="/redeem" className="inline-block px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700">Try again</Link>
          </div>
        )}
      </div>
    </div>
  );
}
